import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId, WHATSAPP_URL } from "@/data/site";

const LINKS = [
  { label: "Servicios", href: "#servicios", testid: "nav-services-link" },
  { label: "Opiniones", href: "#opiniones", testid: "nav-testimonials-link" },
  { label: "Presupuesto", href: "#presupuesto", testid: "nav-budget-link" },
  { label: "Contacto", href: "#contacto", testid: "nav-contact-link" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4"
    >
      <nav
        data-testid="main-nav"
        className={`flex w-full max-w-6xl items-center justify-between rounded-full border px-5 py-3 transition-all duration-500 ${
          scrolled
            ? "bg-white/85 backdrop-blur-xl border-slate-200 shadow-lg shadow-slate-900/5"
            : "bg-white/60 backdrop-blur-md border-slate-200/60"
        }`}
      >
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span className="h-2.5 w-2.5 rounded-full bg-[#00F0FF] shadow-[0_0_12px_#00F0FF] group-hover:scale-125 transition-transform" />
          <span className="font-display text-lg font-extrabold tracking-tight text-slate-900">
            SOCIFY<span className="text-[#1D4ED8]">.</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => scrollToId(l.href)}
              className="font-mono-sig text-[11px] uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <a
          data-testid="nav-cta-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-1.5 rounded-full bg-slate-900 px-4 py-2 text-xs font-bold text-white hover:bg-[#1D4ED8] transition-colors"
        >
          Presupuesto
          <ArrowUpRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </a>
      </nav>
    </motion.header>
  );
}
